var commonModule = angular.module('common', ['angular-zipcode-filter']).filter('tel', function () {
    return function (phoneNumber) {
        if (!phoneNumber)
            return phoneNumber;

        return formatLocal('US', phoneNumber);
    }
});
